import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import { ISO4217 } from '../entities/order';
import { getGlobalConfig } from './config';

dayjs.extend(duration);

// 格式化文件大小
export const formatFileSize = (originalSize: number, round?: boolean): string => {
  if (!originalSize) {
    return '0';
  }
  const isRound = round ?? true;
  const UNIT_MAP = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const index = Math.floor(Math.log(originalSize) / Math.log(1024));
  const formateSize = originalSize / Math.pow(1024, index);
  const size = isRound ? Math.floor(formateSize) : formateSize.toFixed(2);
  console.log(size, UNIT_MAP[index]);
  return size + UNIT_MAP[index];
};

// 格式化金额：分 -> 元 & 增加前缀
export function formatPrice(fen: number, locales?: ISO4217) {
  const { isCN } = getGlobalConfig();
  let prefix = isCN ? '¥' : '$';

  if (locales) {
    switch (locales) {
      case 'CNY':
        prefix = '¥';
        break;
      default:
        prefix = '$';
    }
  }

  const v = (fen / 100).toFixed(2);
  if (v.split('.')[1] === '00') {
    return {
      prefix,
      value: Math.floor(+v),
      string: prefix + Math.floor(+v),
    };
  }
  return { prefix, value: +v, string: prefix + v };
}

// 格式化时间
export function formatTime(date?: Date | string, format = 'YYYY-MM-DD HH:mm:ss') {
  return date ? dayjs(date).format(format) : '';
}

// 格式化时长
export const formatDuration = (
  milliseconds: number,
  customFormat?: (d: plugin.Duration) => string,
) => {
  const d = dayjs.duration(milliseconds);
  if (customFormat) {
    return customFormat(d);
  }
  let builtinFormat = 'mm:ss';
  if (d.hours() > 0) {
    builtinFormat = `HH:${builtinFormat}`;
  }
  return d.format(builtinFormat);
};
